module.exports = __webpack_public_path__ + "img/Deal.2dda9988.svg";